import {z as r} from 'zod';

export type ExportExcelType = {
    filterKey?: string | null;
    date: string;
    comparedDate: string;
};

const competitorInfoSchema = r.object({
    permalink: r.number(),
    percentage: r.number(),
    positionChange: r.number(),
    hasLogo: r.boolean(),
    hasOwner: r.boolean(),
    hasPromotion: r.boolean(),
    orgName: r.string(),
    goodsAmount: r.number(),
    mainRubric: r.string(),
    mainUrl: r.string(),
    photosAmount: r.number(),
    promotionsAmount: r.number(),
    reviewsAmount: r.number(),
    spravRating: r.string(),
    spravRatingAmount: r.number(),
    isOwnCompany: r.boolean(),
});

export enum PositionChangeEnum {
    Improved = 'improved',
    Worsened = 'worsened',
}

const competitorsSchema = r.object({
    permalinkId: r.string(),
    weeklyExtraViews: r.number(),
    growthPotentialPercent: r.number(),
    targetRating: r.number(),
    ratingIncreaseNeeded: r.number(),
    targetReviews: r.number(),
    reviewsToAttract: r.number(),
    targetPhotos: r.number(),
    photosToUpload: r.number(),
    reviewsAmount: r.number(),
    goodsAmount: r.number(),
    promotionsAmount: r.number(),
    percentage: r.number(),
    competitorsList: r.array(competitorInfoSchema),
    position: r.number(),
    id: r.number(),
    code: r.string(),
    name: r.string(),
    addressCityName: r.string(),
    addressAddsFormatted: r.string(),

    positionChange: r.nativeEnum(PositionChangeEnum).nullish(),
});

export const summarySchema = r.object({
    avgPosition: r.object({
        current: r.number(),
        compared: r.number(),
        delta: r.number(),
    }),
    cardsImprovedPosition: r.number(),
    cardsWorsenedPosition: r.number(),
    potentialGrowthImpressions: r.object({
        current: r.number(),
        compared: r.number(),
        delta: r.number(),
    }),
    potentialGrowthCalls: r.number(),
    potentialGrowthWebsite: r.number(),
});

export const competitorsTableResponseSchema = r.object({
    items: r.array(competitorsSchema),
    page: r.number(),
    pageSize: r.number(),
    total: r.number(),
});

export type CompetitorsSummaryStatsRequestType = {
    filterKey?: string;
    currentDate: string;
    comparedDate: string;
};

export type CompetitorsTableRequestOptionsType = {
    date: string;
    filterKey?: string | null;
    sortBy?: string;
    sortOrder?: 'asc' | 'desc';
    page: number;
    pageSize: number;
    positionChange?: PositionChangeEnum | null;
    comparedDate?: string;
};

export type SummaryType = r.infer<typeof summarySchema>;

export type CompetitorsType = r.infer<typeof competitorsSchema>;

export type CompetitorsTableResponseType = r.infer<typeof competitorsTableResponseSchema>;
